import Marquee from 'react-fast-marquee';

export const TrustLogos = () => {
  const logos = [
    'TechLogix',
    'BuildCorp',
    'Global Freight',
    'Metro Distribution',
    'Prime Logistics',
    'Swift Transport',
    'Urban Manufacturing',
    'Apex Industries',
  ];

  return (
    <section className="py-12 bg-[#F5F7FA] border-y border-[#E2E8F0]" data-testid="trust-logos-section">
      <div className="container-custom mb-6">
        <p className="text-center text-sm text-[#64748B] uppercase tracking-[0.2em] font-bold">
          Trusted by businesses across the GTA
        </p>
      </div>
      <Marquee
        gradient={true}
        gradientColor="#F5F7FA"
        gradientWidth={100}
        speed={40}
        className="trust-marquee"
      >
        {logos.map((logo, index) => (
          <div key={index} className="trust-logo mx-8">
            <span className="text-[#64748B] hover:text-[#0B1F3A] transition-colors cursor-default">
              {logo}
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
